import { PropsWithChildren } from "react";
import { RingLoaderIcon } from "../../assests/icons/Icons";

export interface IButtonProps {
  className?: string;
  type?: "submit" | "reset" | "button";
  id?: string;
  name?: string | JSX.Element;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  title?: string;
  children?: JSX.Element | string;
  dataTooltipId?: string;
  isLoading?: boolean;
  loadingTitle?: string;
  RightIcon?: JSX.Element;
  LeftIcon?: JSX.Element;
}

export const Button: React.FC<PropsWithChildren<IButtonProps>> = ({
  className, type = "button", id, name, onClick, disabled, title, children,
  dataTooltipId, isLoading = false, loadingTitle = "Please Wait", RightIcon, LeftIcon
}) => {
  return (
    <button data-tooltip-id={dataTooltipId} title={title} className={`${className} relative flex items-center gap-2 justify-center ${disabled ? "cursor-not-allowed opacity-60" : ""}`} type={type} id={id} onClick={onClick} disabled={disabled || isLoading}>
      {isLoading ? (
        <><RingLoaderIcon size={2} /> <span className="text-nowrap">{loadingTitle}</span></>
      ) : (
        <>
          {LeftIcon}
          <span>{children ?? name}</span>
          {RightIcon}
        </>
      )}
    </button>
  );
};